import React, { createContext, useCallback } from 'react'


export const PaymentFlowContext = createContext<PaymentModule.PaymentFlowContext>(null)


type FlowProviderProps = {
  className?: string
  value: PaymentModule.PaymentFlowContext
}

const PaymentFlowProvider: React.CFC<FlowProviderProps> = (props) => {
  const { children, className, value } = props

  // prevent form from submitting
  const handleSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
  }, [])

  const isProcessing = value.isProcessing

  // form is required for credit card flow
  return (
    <form
      ref={value.formRef}
      className={className}
      style={isProcessing ? { pointerEvents: 'none' } : null}
      noValidate
      onSubmit={handleSubmit}
      aria-busy={isProcessing}
      data-testid="paymentForm"
    >
      <PaymentFlowContext.Provider value={value}>
        {children}
      </PaymentFlowContext.Provider>
    </form>
  )
}


export default PaymentFlowProvider
